module.exports = __webpack_public_path__ + "img/boot.779381b9.png";